import firestore, { Timestamp } from 'firebase/firestore';

export class Clients {
    idClient: string;

    idGroupe: string;

    mail: string;

    nom: string;

    prenom: string;

    adresse: string;

    dateNaissance: Timestamp;

    urlPhoto: string;

    constructor({
        idClient,
        idGroupe,
        mail,
        nom,
        prenom,
        adresse,
        dateNaissance,
        urlPhoto
    }: {
        idClient: string;
        idGroupe: string;
        mail: string;
        nom: string;
        prenom: string;
        adresse: string;
        dateNaissance: Timestamp;
        urlPhoto: string;
    }) {
        this.idClient = idClient;
        this.idGroupe = idGroupe;
        this.mail = mail;
        this.nom = nom;
        this.prenom = prenom;
        this.adresse = adresse;
        this.dateNaissance = dateNaissance;
        this.urlPhoto = urlPhoto;
    }
}

export const ClientsConverter: firestore.FirestoreDataConverter<Clients> = {
    toFirestore(clients) {
        return {
            idClient: clients.idClient,
            idGroupe: clients.idGroupe,
            mail: clients.mail,
            nom: clients.nom,
            prenom: clients.prenom,
            adresse: clients.adresse,
            dateNaissance: clients.dateNaissance,
            urlPhoto: clients.urlPhoto
        };
    },
    fromFirestore(snapshot, options): Clients {
        const data = snapshot.data(options);
        return new Clients({
            idClient: data.idClient,
            idGroupe: data.idGroupe,
            mail: data.mail,
            nom: data.nom,
            prenom: data.prenom,
            adresse: data.adresse,
            dateNaissance: data.dateNaissance,
            urlPhoto: data.urlPhoto
        });
    }
};
